import { darken , lighten} from "@mui/material";
import lightOrdarkColor from "@check-light-or-dark/color";

const MuiDivider = {
  styleOverrides: {
    root: ({theme} : any) => ({
      borderBottom: lightOrdarkColor(theme.palette.background.default) === 'dark' ? `1px solid  ${lighten(theme.palette.background.default, 0.1)}` :  `1px solid  ${darken(theme.palette.background.default, 0.1)}` ,//theme.palette.text.primary,
    }),
  },
};

export default MuiDivider;
